// extracted by mini-css-extract-plugin
export default {"dropzone":"UploadFile_dropzone__vx1+-","reject":"UploadFile_reject__Rdo+E","accept":"UploadFile_accept__PlN9N","contentWrapper":"UploadFile_contentWrapper__zrM8l"};